import clsx from 'clsx';
import Image from '@/components/Image';
import Tooltip from '@/components/Tooltip';

function renderTrainerTooltip(trainerCountry) {
  return function (tooltip, addDefaultClassName = true, attrs = {}) {
    return (
      <div tabIndex="-1" {...attrs}>
        <div className="bg-white rounded-full shadow-xl px-6 py-2 leading-normal transition ease-in-out duration-300 transform flex flex-col ring-1 ring-black ring-opacity-5">
          <div className="text-gray-900 text-sm font-medium leading-4">
            {tooltip}
          </div>
          <div className="text-xs text-gray-700 leading-4">
            {trainerCountry}
          </div>
        </div>
      </div>
    );
  };
}

function CoachTrainingTrainerPicture({
  picture,
  trainerName,
  country,
  stylePosition,
  animation,
}) {
  return (
    <Tooltip
      tooltip={trainerName}
      renderTooltip={renderTrainerTooltip(country)}
    >
      <button
        className={clsx(
          'cursor-pointer w-14 h-14 bg-white absolute z-20 rounded-full shadow-lg focus:outline-none transform origin-center',
          animation
        )}
        style={stylePosition}
        type="button"
      >
        <Image
          src={`entrenadores/${picture}`}
          alt={trainerName}
          className="w-full h-full rounded-full transform hover:scale-125 transition ease-linear"
          width={180}
          height={180}
        />
      </button>
    </Tooltip>
  );
}

export default function CoachTrainingAnimation() {
  return (
    <div className="relative py-32 lg:absolute z-20 inset-0 grid grid-cols-1 lg:grid-cols-12 lg:items-center">
      <div className="lg:col-span-6 lg:col-start-8 flex items-center justify-center">
        <div
          className="rounded-full"
          style={{ width: '210px', height: '210px' }}
        >
          <Image
            src="formacion/official-scrum-trainer-badge.png"
            alt="Official Scrum Trainer Certification"
            className="rounded-full w-full h-full shadow-outside-lg"
            width={300}
            height={300}
          />
        </div>
        <div
          className="w-96 h-96 absolute rounded-full opacity-10 z-0"
          style={{ width: '350px', height: '350px' }}
        >
          <div
            className="w-full h-full border border-gray-900 rounded-full absolute shadow-outside-lg"
            style={{ width: '350px', height: '350px' }}
          />
        </div>
        <div
          className="w-96 h-96 absolute rounded-full z-20 animate-spin-slow"
          style={{ width: '500px', height: '500px' }}
        >
          <CoachTrainingTrainerPicture
            picture="carlos-paulino.png"
            trainerName="Carlos Paulino"
            country="República Dominicana"
            animation="animate-spin-backwords-slow"
            stylePosition={{ left: '210px', top: '-26px' }}
          />
          <CoachTrainingTrainerPicture
            picture="pedro-nogales.webp"
            trainerName="Pedro Nogales"
            country="Estados Unidos"
            animation="animate-spin-backwords-slow"
            stylePosition={{ left: '340px', bottom: '5px' }}
          />
          <CoachTrainingTrainerPicture
            picture="linnet-acosta.webp"
            trainerName="Linnet Acosta"
            country="Canadá"
            animation="animate-spin-backwords-slow"
            stylePosition={{ left: '140px', bottom: '-90px' }}
          />
          <CoachTrainingTrainerPicture
            picture="federico-vargas.jpg"
            trainerName="Federico Vargas"
            country="Costa Rica"
            animation="animate-spin-backwords-slow"
            stylePosition={{ left: '40px', top: '50px' }}
          />
          <CoachTrainingTrainerPicture
            picture="jimena-canales.png"
            trainerName="Jimena Canales"
            country="Perú"
            animation="animate-spin-backwords-slow"
            stylePosition={{ right: '40px', top: '50px' }}
          />
          <CoachTrainingTrainerPicture
            picture="javier-martin-agar.jpg"
            trainerName="Javier Martín Agar"
            country="España"
            animation="animate-spin-backwords-slow"
            stylePosition={{ left: '210px', bottom: '50px' }}
          />
          <CoachTrainingTrainerPicture
            picture="sandy-rodriguez.jpg"
            trainerName="Sandy Rodríguez"
            country="México"
            animation="animate-spin-backwords-slow"
            stylePosition={{ left: '20px', bottom: '75px' }}
          />
          <CoachTrainingTrainerPicture
            picture="adonis-rosales.png"
            trainerName="Adonis Rosales"
            country="Canadá"
            animation="animate-spin-backwords-slow"
            stylePosition={{ right: '25px', bottom: '75px' }}
          />
          <CoachTrainingTrainerPicture
            picture="Antonio_perfil.jpg"
            trainerName="Antonio Betancourt"
            country="Chile"
            animation="animate-spin-backwords-slow"
            stylePosition={{ left: '50px', top: '210px' }}
          />
          <CoachTrainingTrainerPicture
            picture="erick-masgo.webp"
            trainerName="Erick Masgo"
            country="Perú"
            animation="animate-spin-backwords-slow"
            stylePosition={{ left: '-100px', top: '210px' }}
          />
          <CoachTrainingTrainerPicture
            picture="annabel-chelton.jpg"
            trainerName="Annabell Schelton"
            country="Chile"
            animation="animate-spin-backwords-slow"
            stylePosition={{ right: '50px', top: '200px' }}
          />
          <CoachTrainingTrainerPicture
            picture="lucho-salazar.jpg"
            trainerName="Lucho Salazar"
            country="Colombia"
            animation="animate-spin-backwords-slow"
            stylePosition={{ right: '-100px', top: '220px' }}
          />
        </div>
        <div
          className="w-96 h-96 border border-gray-800 opacity-20 absolute rounded-full animate-spin-slow z-0 shadow-outside-lg"
          style={{ width: '500px', height: '500px' }}
        />
        <div
          className="w-96 h-96 border border-gray-500 opacity-20 absolute rounded-full animate-spin-slow shadow-outside-lg z-0"
          style={{ width: '650px', height: '650px' }}
        />
      </div>
    </div>
  );
}
